module.exports = "<app-search-bar btnName=\"Quanto vale?\" (onSearch)=\"onSearch($event)\"></app-search-bar>\n\n<!--<div>adv</div>-->\n\n<h2>I cellulari pi&ugrave; ricercati</h2>\n<!--<app-variant-list [variants]=\"highlights\"></app-variant-list>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/home-page/home-page.component.html
// module id = 745
// module chunks = 1